/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'goal-actions.goal-content-about.edit-description-error-description':
    '問題が発生しました。しばらくしてから再度お試しください。',
  'goal-content.goal-about-content.description-edit-button': '編集',
  'goal-content.goal-about-content.description-title': '説明',
  'goal-content.goal-about-content.placeholder-description':
    'このゴールが重要である理由と、成功を測定する方法を簡潔に説明し、フォロワー全員が共通の理解を持てるようにします。',
  'goal-content.goal-content-about.edit-description-error-title': 'ゴールの説明を編集できませんでした',
  'goal-content.goal-content-update-date.edited': '(編集済み)',
  'goal-content.goal-content-update-date.edited-tooltip': '編集日: {date}',
  'goal-content.goal-content-update-date.last-edited-by': '(最終編集者: {name})',
  'goal-content.goal-content-updates.add-update': '最新情報を追加',
  'goal-content.goal-content-updates.archived': 'アーカイブ済み',
  'goal-content.goal-content-updates.at-risk': 'リスクあり',
  'goal-content.goal-content-updates.cancelled': 'キャンセル済み',
  'goal-content.goal-content-updates.completed': '完了 🎉',
  'goal-content.goal-content-updates.date-changed': '日付が変更されました',
  'goal-content.goal-content-updates.edit-update': '編集',
  "goal-content.goal-content-updates.for-date'": ': {dueDate}',
  'goal-content.goal-content-updates.latest-update-title': '前回更新',
  'goal-content.goal-content-updates.missed-update-message': '最新情報の投稿はありません',
  'goal-content.goal-content-updates.new-due-date': '新しい期限',
  'goal-content.goal-content-updates.new-state': '新しい状態',
  'goal-content.goal-content-updates.no-updates-description': 'このゴールの最新情報はまだありません。',
  'goal-content.goal-content-updates.off-track': '遅延',
  'goal-content.goal-content-updates.old-due-date': '以前の期限',
  'goal-content.goal-content-updates.old-state': '以前の状態',
  'goal-content.goal-content-updates.on-track': '順調',
  'goal-content.goal-content-updates.paused': '一時停止中',
  'goal-content.goal-content-updates.pending': '保留中',
  'goal-content.goal-content-updates.previous-updates-title': '前の最新情報',
  'goal-content.goal-content-updates.share-update': '共有',
  'goal-content.goal-content-updates.status-changed': 'ステータスが変更されました',
  'goal-content.goal-content-updates.write-update-button': '最新情報を作成',
  'goal-content.goal-update-composer.modal-title': '最新情報を投稿',
  'goal-content.goal-update-composer.post-button-label': '最新情報を投稿',
};
